module.exports = __webpack_public_path__ + "img/3.01ad5a7e.jpg";